import type { AIVoice } from 'js/src/client';
import { getCanUsePremiumAIVoices } from 'js/src/data/account/account-selectors';
import PlainJsStoreORM from 'js/src/data/plain-js-store-orm';
import type { RootState } from 'js/src/libs/RootState';

export function isAIVoiceAvailableToTeam(
    state: RootState,
    voice: AIVoice | null,
): voice is AIVoice {
    return (
        voice !== null &&
        !voice.is_deprecated &&
        (!voice.is_paid || getCanUsePremiumAIVoices(state))
    );
}

export function getAIVoicesState(state: RootState) {
    return state.aiVoicesAndAvatars?.aiVoices;
}

// Shared so pages without the slice get a stable `allIds` reference — a fresh
// empty each call would make `useSelector` re-render on every store update.
const EMPTY_AI_VOICES_ORM = PlainJsStoreORM.createEmpty<AIVoice, string>();

function getAIVoicesStoreORM(aiVoicesState: ReturnType<typeof getAIVoicesState>) {
    if (!aiVoicesState) {
        return EMPTY_AI_VOICES_ORM;
    }
    return new PlainJsStoreORM(aiVoicesState);
}

export function getAIVoiceIds(state: RootState): string[] {
    return getAIVoicesStoreORM(getAIVoicesState(state)).allIds;
}

export function getAIVoiceById(state: RootState, id: string): AIVoice | null {
    return getAIVoicesStoreORM(getAIVoicesState(state)).getById(id) || null;
}
